// @ts-nocheck
/* ==========================================================================
   Kult-Rösterei — PLP Kaffee (Paket 2b)
   Web Component <kult-plp-filters> (in snippets/kult-plp-filters.liquid,
   gerendert von sections/kult-plp-main.liquid): Accordion-Sidebar mit
   Sortieren/Zubereitung/Intensität/Aroma. Sortiert und filtert die
   serverseitig gerenderten Karten (.kult-plp-card) client-seitig ohne
   Reload und hält dabei EINE gemeinsame Filterfunktion mit der
   Zubereitungsart-Quickbar im Hero (sections/kult-plp-hero.liquid) —
   keine zwei Logiken. Nutzt assets/kult-motion.js für Reveals.
   ========================================================================== */
(function () {
  'use strict';

  function cardTags(card) {
    return (card.getAttribute('data-tags') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  }

  function cardHasTag(card, tag) { return cardTags(card).indexOf(tag) !== -1; }
  function cardOrder(card) { return parseInt(card.getAttribute('data-order'), 10) || 0; }
  function cardCreated(card) { return parseInt(card.getAttribute('data-created'), 10) || 0; }
  function cardPrice(card) { return parseFloat(card.getAttribute('data-base-price')) || 0; }
  /* Intensität als Dezimalzahl mit halben Stufen (02.10.2026): auf eine Nachkommastelle runden, Anzeige mit Komma */
  function stepNum(value, fallback) { var n = parseFloat(value); return isNaN(n) ? fallback : Math.round(n * 10) / 10; }
  function stepText(value) { return String(value).replace('.', ','); }
  function cardIntensity(card) { return stepNum(card.getAttribute('data-intensity'), 0); }

  function checkedValues(list) {
    return Array.prototype.filter.call(list, function (c) { return c.checked; }).map(function (c) { return c.value; });
  }

  function initFilters(root) {
    var grid = document.querySelector('.kult-plp-grid');
    var emptyState = document.querySelector('.kult-plp-empty');
    var quickBtns = document.querySelectorAll('.kult-plp-quickbar__btn');
    var filterToggle = document.querySelector('.kult-plp-toolbar__filter-toggle');
    var filterCountBadge = document.querySelector('.kult-plp-toolbar__filter-count');
    var plpLayout = root.closest('.kult-plp-layout');

    var prepChecks = root.querySelectorAll('.kult-plp-filter-checkbox[data-filter="zubereitung"]');
    var aromaChecks = root.querySelectorAll('.kult-plp-filter-checkbox[data-filter="aroma"]');
    var sortRadios = root.querySelectorAll('.kult-plp-filter-radio');
    var intensityRange = root.querySelector('[data-range="intensity"]');
    var intensityOut = root.querySelector('[data-range-value="intensity"]');
    var resetBtn = root.querySelector('.kult-plp-sidebar__reset');

    var DESKTOP_BREAKPOINT = 960;

    function currentSortMode() {
      var checked = Array.prototype.filter.call(sortRadios, function (r) { return r.checked; })[0];
      return checked ? checked.getAttribute('data-sort') : 'empfohlen';
    }

    function isOnlyPrepChecked(method) {
      if (!method) return false;
      return Array.prototype.every.call(prepChecks, function (c) {
        return c.value === method ? c.checked : !c.checked;
      });
    }

    function syncQuickbar() {
      quickBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', isOnlyPrepChecked(btn.getAttribute('data-method')));
      });
    }

    function matchesPrep(card) {
      var checked = checkedValues(prepChecks);
      if (!checked.length) return true;
      var tags = cardTags(card);
      return checked.some(function (val) { return tags.indexOf('zubereitung_' + val) !== -1; });
    }

    function matchesAroma(card) {
      var checked = checkedValues(aromaChecks);
      if (!checked.length) return true;
      var tags = cardTags(card);
      return checked.every(function (val) { return tags.indexOf('aroma_' + val) !== -1; });
    }

    function rangeMin() { return stepNum(intensityRange.min, 1); }
    function rangeValue() { return stepNum(intensityRange.value, rangeMin()); }
    function intensityIsActive() { return !!intensityRange && rangeValue() > rangeMin(); }

    function showIntensityValue() {
      var txt = stepText(rangeValue());
      if (intensityOut) intensityOut.textContent = txt;
      intensityRange.setAttribute('aria-valuetext', 'ab ' + txt);
    }

    function matchesIntensity(card) {
      if (!intensityRange) return true;
      return cardIntensity(card) >= rangeValue();
    }

    function repositionContentCard() {
      if (!grid) return;
      var contentCard = grid.querySelector('.kult-plp-content-card');
      if (!contentCard) return;
      var visible = Array.prototype.filter.call(grid.querySelectorAll('.kult-plp-card'), function (c) {
        return !c.classList.contains('is-hidden');
      });
      // Beratungs-Karte steht immer am Ende der Produktliste (Nutzer-Entscheidung 15.09.2026)
      grid.appendChild(contentCard);
      // … und die Probierset-/Kult-Abo-Kacheln (18.10.2026) dahinter als Abschluss
      grid.querySelectorAll('.kult-plp-extra').forEach(function (extra) { grid.appendChild(extra); });
    }

    function updateFilterCountBadge() {
      if (!filterCountBadge) return;
      var count = 0;
      if (currentSortMode() !== 'empfohlen') count++;
      count += checkedValues(prepChecks).length;
      if (intensityIsActive()) count++;
      count += checkedValues(aromaChecks).length;
      filterCountBadge.textContent = count;
      filterCountBadge.setAttribute('data-count', count);
    }

    function applyFilters() {
      if (!grid) return;
      var visibleCount = 0;
      grid.querySelectorAll('.kult-plp-card').forEach(function (card) {
        var visible = matchesPrep(card) && matchesAroma(card) && matchesIntensity(card);
        card.classList.toggle('is-hidden', !visible);
        if (visible) visibleCount++;
      });
      if (emptyState) {
        // Leerzustand-Text steht nur im data-Attribut (SEO, 18.10.2026) und kommt erst bei 0 Treffern in den DOM
        if (visibleCount === 0 && !emptyState.textContent) emptyState.textContent = emptyState.getAttribute('data-empty-text') || '';
        emptyState.classList.toggle('is-visible', visibleCount === 0);
      }
      var countEl = document.querySelector('[data-plp-count]');
      if (countEl) countEl.textContent = visibleCount + (visibleCount === 1 ? ' Sorte' : ' Sorten');
      repositionContentCard();
      updateFilterCountBadge();
    }

    /* Bestseller-Rang (07.10.2026, Anforderung Philip): 0 = Bestseller der aktiven Zubereitung/des aktiven Aromas
       (Tags bestseller_zubereitung_<wert> / bestseller_aroma_<wert> aus der Kult-Events-App), bei beiden Filtern
       zuerst die, die in beiden Gruppen Bestseller sind; danach globaler Tag „bestseller“; dann der Rest.
       Fehlen Gruppen-Tags noch, greift automatisch der globale Tag. */
    function bestsellerRank(card) {
      var tags = cardTags(card);
      var has = function (t) { return tags.indexOf(t) !== -1; };
      var groups = [];
      var prep = checkedValues(prepChecks);
      var aroma = checkedValues(aromaChecks);
      if (prep.length) groups.push(prep.map(function (v) { return 'bestseller_zubereitung_' + v; }));
      if (aroma.length) groups.push(aroma.map(function (v) { return 'bestseller_aroma_' + v; }));
      var hits = groups.filter(function (g) { return g.some(has); }).length;
      var rank = groups.length + 1 - hits; /* alle Gruppen getroffen = 1 */
      if (hits === 0) rank = has('bestseller') ? groups.length + 1 : groups.length + 2;
      return hits === groups.length && hits > 0 ? 0 : rank;
    }

    function sortCards() {
      if (!grid) return;
      var mode = currentSortMode();
      var list = Array.prototype.slice.call(grid.querySelectorAll('.kult-plp-card'));
      var intensityActive = intensityIsActive();
      list.sort(function (a, b) {
        /* Nutzer-Sortierung: nur die gewählte Sortierung, keine Bestseller- oder Intensitäts-Vorsortierung */
        if (mode === 'neuheiten') {
          var aNew = cardHasTag(a, 'neuheit') ? 0 : 1;
          var bNew = cardHasTag(b, 'neuheit') ? 0 : 1;
          return aNew !== bNew ? aNew - bNew : cardCreated(b) - cardCreated(a);
        }
        if (mode === 'preis-aufsteigend') return cardPrice(a) - cardPrice(b) || cardOrder(a) - cardOrder(b);
        if (mode === 'preis-absteigend') return cardPrice(b) - cardPrice(a) || cardOrder(a) - cardOrder(b);
        if (mode === 'name') return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '', 'de');
        /* Standard „Bestseller zuerst“: Bestseller-Rang je aktivem Filter, dann (bei Intensitäts-Filter) Intensität, dann Kollektionsreihenfolge */
        var ar = bestsellerRank(a);
        var br = bestsellerRank(b);
        if (ar !== br) return ar - br;
        if (intensityActive) {
          var ai = cardIntensity(a);
          var bi = cardIntensity(b);
          if (ai !== bi) return ai - bi;
        }
        return cardOrder(a) - cardOrder(b);
      });
      list.forEach(function (card) { grid.appendChild(card); });
      // Probierset-/Kult-Abo-Kacheln (18.10.2026) bleiben nach jeder Sortierung die letzten Kacheln
      grid.querySelectorAll('.kult-plp-extra').forEach(function (extra) { grid.appendChild(extra); });
    }

    function update() {
      sortCards();
      applyFilters();
    }

    quickBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var method = btn.getAttribute('data-method');
        var solo = isOnlyPrepChecked(method);
        prepChecks.forEach(function (c) { c.checked = !solo && c.value === method; });
        syncQuickbar();
        update();
      });
    });

    prepChecks.forEach(function (chk) {
      chk.addEventListener('change', function () {
        syncQuickbar();
        update();
      });
    });

    aromaChecks.forEach(function (chk) {
      chk.addEventListener('change', update);
    });

    sortRadios.forEach(function (radio) {
      radio.addEventListener('change', update);
    });

    if (intensityRange) {
      intensityRange.addEventListener('input', function () {
        showIntensityValue();
        update();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        sortRadios.forEach(function (r) { r.checked = r.getAttribute('data-sort') === 'empfohlen'; });
        prepChecks.forEach(function (c) { c.checked = false; });
        aromaChecks.forEach(function (c) { c.checked = false; });
        if (intensityRange) {
          intensityRange.value = intensityRange.min || 1;
          showIntensityValue();
        }
        syncQuickbar();
        update();
      });
    }

    function setFiltersOpen(isOpen) {
      plpLayout.classList.toggle('is-filters-open', isOpen);
      filterToggle.classList.toggle('is-active', isOpen);
      filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (filterToggle && plpLayout) {
      setFiltersOpen(window.innerWidth >= DESKTOP_BREAKPOINT && plpLayout.getAttribute('data-filters-default') !== 'closed');
      filterToggle.addEventListener('click', function () {
        setFiltersOpen(!plpLayout.classList.contains('is-filters-open'));
      });
    }

    /* Vorbelegung nur noch ausdrücklich (12.10.2026, Cowork U22): Unterkategorie (Liquid preselect_method) oder
       URL-Parameter ?zubereitung=<wert> (z. B. „Alle 7 Sorten für Handfilter“ aus der Kaffeezubereitung).
       Die gemerkte Zubereitung (localStorage 'kult:method') filtert nicht mehr vor: Die Übersicht verspricht
       „13 Sorten“ und zeigt ohne versteckten Filter alle. ?zubereitung=alle (snippets/kult-all-url) bleibt ungefiltert. */
    if (!Array.prototype.some.call(prepChecks, function (c) { return c.checked; })) {
      var wanted = '';
      try { wanted = new URLSearchParams(window.location.search).get('zubereitung') || ''; } catch (e) { wanted = ''; }
      if (wanted && wanted !== 'alle') prepChecks.forEach(function (c) { c.checked = c.value === wanted; });
    }
    syncQuickbar();
    sortCards();
    if (Array.prototype.some.call(prepChecks, function (c) { return c.checked; })) update(); /* Vorauswahl aus Unterkategorie oder Erinnerung anwenden */
    applyFilters();
  }

  if (!customElements.get('kult-plp-filters')) {
    customElements.define('kult-plp-filters', class KultPlpFilters extends HTMLElement {
      connectedCallback() {
        if (this._kultInitialized) return;
        this._kultInitialized = true;
        initFilters(this);
      }
    });
  }
})();

/* Zubereitungs-Pills im Hero (28.09.2026): nach dem Filtern zur Kaffeeliste scrollen */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kult-plp-quickbar__btn');
    if (!btn) return;
    var grid = document.querySelector('.kult-plp-toolbar') || document.querySelector('.kult-plp-grid');
    if (!grid) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(function () { grid.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, 120);
  }, true); /* Capture-Phase: der Filter-Handler der Pills stoppt die Propagation */
})();
